import { Component } from '@angular/core';

@Component({
  selector: 'app-learning-platform',
  templateUrl: './learning-platform.component.html',
  styleUrls: ['./learning-platform.component.css']
})
export class LearningPlatformComponent {

}
